import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import {
  VehicleSelection,
  Make,
} from '@/components/VehicleSearchForm/YMMSearchForm/ymmSearch';
import { useVehicleSearchByTrim } from '@/hooks/useVehicleSearchByTrim';
import { ReportSectionStyled } from '@/reports/shared/ReportSection/ReportSection';
import { vehicleSelections } from '@/reports/shared/VendorData/VendorData';
import { Icons, Select, SelectOption, Stack, Text } from '@/theme/index';
import { getVehicleTrims } from '@/utils/index';

const DEFAULT_TRIM_SELECT_VALUE = 'SELECT A TRIM';

interface VehicleTrimSelectProps {
  make: string;
  model: string;
  year: string;
}

export function VehicleTrimSelect({
  make,
  model,
  year,
}: VehicleTrimSelectProps) {
  const [currentTrim, setCurrentTrim] = useState<string>('');
  const [trims, setTrims] = useState<SelectOption[]>([]);
  const [makesObj, setMakesObj] = useState<Make[]>([]);
  const { data } = useQuery<VehicleSelection>({
    queryKey: ['vehicleSelections'],
    queryFn: () => vehicleSelections(),
  });
  useVehicleSearchByTrim(year, make, model, currentTrim);

  useEffect(() => {
    if (data?.selections) {
      const { selections } = data;
      setMakesObj(selections.makes);
    }
  }, [data]);

  useEffect(() => {
    const basicTrims = getVehicleTrims(make, model, makesObj);
    basicTrims.unshift(DEFAULT_TRIM_SELECT_VALUE);
    setTrims(basicTrims.map((trim) => ({ value: trim, display: trim })));
  }, [makesObj]);

  const handleOptionSelect = (option: string) => {
    setCurrentTrim(option);
  };

  return (
    <ReportSectionStyled id="ymm-report-trim" data-testid="ymm-report-trim">
      <Stack
        direction="row"
        sx={{ alignItems: 'center', mb: '20px' }}
        color="primary"
      >
        <Icons.Tune sx={{ mr: 2 }} color="primary" />
        <Text variant="h2" sx={{ mb: 0 }} color="primary">
          Select a trim to see specific results
        </Text>
      </Stack>
      <Select
        id="ymm-report-trim-select"
        data-testid="ymm-report-trim-select"
        options={trims}
        defaultValue={DEFAULT_TRIM_SELECT_VALUE}
        onOptionSelect={handleOptionSelect}
      />
    </ReportSectionStyled>
  );
}
